require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-what-to-do-and-not-do-when-buying-into-a-development.json") })
        }
      }, "path---news-what-to-do-and-not-do-when-buying-into-a-development");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-what-to-do-and-not-do-when-buying-into-a-development!./.cache/json/news-what-to-do-and-not-do-when-buying-into-a-development.json
// module id = 864
// module chunks = 231608221292675